import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ITenantUser from '../model/ITenantUser'

export type MemberReportState = {
  status: 'idle' | 'loading' | 'loaded' | 'error'
  // Raw report as the backend wrote it; parsed where it's displayed.
  csv: string
  generatedAt: string | null
  dialogOpen: boolean
  // A report finished while the dialog was closed; shows the "ready" snack.
  ready: boolean
}

type UserState = {
  users: ITenantUser[]
  loadingUsers: boolean
  memberReport: MemberReportState
  rowsPerPage: number
}

const initState: UserState = {
  users: new Array<ITenantUser>(),
  loadingUsers: false,
  memberReport: {
    status: 'idle',
    csv: '',
    generatedAt: null,
    dialogOpen: false,
    ready: false
  },
  rowsPerPage: 25
}

const usersSlice = createSlice({
  name: 'users',
  initialState: initState as UserState,
  reducers: {
    setLoadingUsers: (
      state,
      action: PayloadAction<{ loadingUsers: boolean }>
    ): UserState => {
      return {
        ...state,
        loadingUsers: action.payload.loadingUsers
      }
    },
    setMemberReport: (
      state,
      action: PayloadAction<Partial<MemberReportState>>
    ): UserState => {
      return {
        ...state,
        memberReport: { ...state.memberReport, ...action.payload }
      }
    },
    setUsers: (
      state,
      action: PayloadAction<{ users: ITenantUser[] }>
    ): UserState => {
      return {
        ...state,
        users: action.payload.users
      }
    },
    setUsersRowsPerPage: (
      state,
      action: PayloadAction<{ rowsPerPage: number }>
    ): UserState => {
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage
      }
    }
  }
})

export const {
  setLoadingUsers,
  setMemberReport,
  setUsers,
  setUsersRowsPerPage
} = usersSlice.actions

export default usersSlice.reducer
